<div *ngIf="loading" class="flex align-items-center justify-content-center w-full pb-8 mb-8">
	<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
</div>

<div *ngIf="!loading">
	<div class="grid mt-0 px-3">
		<!-- DATAS DEVICE EXPORT -->
		<div class="col-12 pt-0">
			<div class="flex justify-content-center">
				<p-button icon="pi cm-download" label="{{ 'EXPORT_METRICS_LIST' | translate }}" (click)="exportLog()"
					[rounded]="false" [text]="true" severity="primary"
					styleClass="font-bold border-primary surface-900 hover:bg-blue-900 w-17rem">
				</p-button>
			</div>
		</div>
		<!-- FUNCTION HIDE, NOT READY YET -->
		<!-- <div class="col-12">
			<app-thermo-log></app-thermo-log>
		</div> -->
	</div>
</div>